import React from 'react';
import { Paper, Stack } from '@mantine/core';
import BillingFilter from '../components/filter/BillingFilter.tsx';
import UnconfirmedBillingTable from '../components/table/UnconfirmedBillingTable.tsx';
import useUnconfirmedBillings from '../hooks/useUnconfirmedBillings.ts';
import { useBillingFilter } from '../hooks/useBillingFilter.tsx';
import { uniqueByKeys } from '../utils/array.ts';

export default function UnconfirmedBillingPage() {
  const { isFetching, data = [] } = useUnconfirmedBillings();
  const { filteredData, handleFilter } = useBillingFilter(data);

  const siteProviders = uniqueByKeys(
    data.map((x) => x.siteProvider),
    ['id'],
  );
  const tags = [...new Set(data.flatMap((x) => x.tags.map((tag) => tag.name)))];

  return (
    <>
      <Paper p="xl" radius="lg" shadow="xl" mb="xl">
        <Stack gap="xl">
          <BillingFilter
            providers={siteProviders}
            tags={tags}
            onFilter={handleFilter}
          />
          <UnconfirmedBillingTable data={filteredData} isLoading={isFetching} />
        </Stack>
      </Paper>
    </>
  );
}
